import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { from, Observable } from 'rxjs';
import { PrefsService } from 'src/app/services/prefs.service';
import { IUserStorageAdapter } from './user-storage.interface';

@Injectable({
  providedIn: 'root'
})
export class UserStorageMobileAdapter implements IUserStorageAdapter {
  constructor(
    private prefsService: PrefsService,
    private storage: Storage,
  ) {}

  migrateToPrefsIfNeeded(key: string): Observable<void> {
    const migratePromise = new Promise<void>(async (resolve, __) => {
      await this.storage.ready();
      const value = await this.storage.get(key);

      if (value !== null) {
        await this.prefsService.getStorePromise(key, value)
        await this.storage.remove(key);
      }

      resolve();
    });

    return from(migratePromise);
  }

  get<T>(key: string): Observable<T | undefined> {
    const getPromise = this.prefsService
      .getPromiseOfTypeOrDefault<T>(key, undefined);

    return from(getPromise);
  }

  set(key: string, value: Object): Observable<void> {
    const setPromise = this.prefsService
      .getStorePromise(key, value)
      .then(() => {});

    return from(setPromise);
  }
}
